import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import Bulk from '@uturn/portal/modules/shipments/pages/shipment-create/bulk';
import z from 'zod';

const ShipmentsAddBulkSearchSchema = z.object({
	transportType: z.enum(['import', 'export', 'shunt']).optional(),
});

export const Route = createFileRoute('/_protected/shipments/add/bulk')({
	validateSearch: zodValidator(ShipmentsAddBulkSearchSchema),
	component: Bulk,
});
